module.exports = __webpack_public_path__ + "components/flag/static/square/sj-6ffe945ebc8ed0f893641d7815eff8f7.svg";